import React from 'react';
import { ResearchIntro } from '../components/research/ResearchIntro';
import { ResearchSkp } from '../components/research/ResearchSkp';
import { ResearchPriorities } from '../components/research/ResearchPriorities';
import { CognarchicFoundation } from '../components/research/CognarchicFoundation';
import { OperationalSystems } from '../components/research/OperationalSystems';
import { ResearchTesting } from '../components/research/ResearchTesting';
import { IdeasSection } from '../components/initiatives/IdeasSection';
export function ResearchPage() {
  return <>
      <ResearchIntro data-id="element-2241" data-mp="35gzf5ich8obl" />
      <IdeasSection id="ideas" tone="muted" title="Ideas & Initiatives" body="Explore how SyNeural’s knowledge infrastructure, capability framework, and interactive workspace could support new approaches to institutional trust, professional development, and civic responsibility." link={{
      label: 'Papers & Publications',
      href: '/roadmap#publications'
    }} data-id="element-2242" data-mp="35gh9xw7u6zrj" />
      <ResearchSkp data-id="element-2243" data-mp="6ws8rkejuimn" />
      <ResearchPriorities data-id="element-2244" data-mp="6wijjz1bwfi0" />
      <CognarchicFoundation data-id="element-2245" data-mp="6zei9pl0387i" />
      <OperationalSystems data-id="element-2246" data-mp="bw4xkaozdzrv" />
      <ResearchTesting data-id="element-2247" data-mp="bxg0k8alr3hx" />
    </>;
}